import { render, staticRenderFns } from "./GrayHeartSVG.vue?vue&type=template&id=a0333606&scoped=true&"
import script from "./GrayHeartSVG.vue?vue&type=script&lang=js&"
export * from "./GrayHeartSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0333606",
  null
  
)

export default component.exports